// extracted by mini-css-extract-plugin
export default {"container":"TX-z","dimension":"UX-z","dimensionLabels":"VX-z"};